import React from "react";
import { Tooltip, Icon } from "antd";

const InfoLabel = ({ label, info, iconType }) => (
  <span>
    {label}&nbsp;
    <Tooltip title={info}>
      <Icon type={iconType || "question-circle-o"} />
    </Tooltip>
  </span>
);

export default InfoLabel;
